// 자체 UI 라이브러리 공용 디자인 토큰 — 사이트 테마(static/theme/palette.js)와 같은 값만 쓴다.
// 주소 검색·물품 수량·결제수단·실시간문의 컴포넌트가 함께 쓰며, 색을 새로 만들지 않고
// 입력창(.textBox)·버튼(CustomButton)·다이얼로그가 쓰는 값에 맞춘다.
const tokens = {
  primary: '#ff925c',        // palette.primary.main
  primaryDark: '#f77c40',    // palette.primary.dark — 강조 글자
  primarySoft: '#fef7f5',    // palette.background.default — 선택·호버 배경
  primaryLine: '#ffe3d8',    // 주황 계열 얇은 테두리(공지 띠와 동일)
  ink: '#161617',            // 본문 진한 글자
  text: '#555558',           // palette.text.primary
  muted: '#a4a4ac',          // palette.text.secondary
  placeholder: '#cacacf',    // 입력창 플레이스홀더
  line: '#e4e4e9',           // 입력창 테두리
  lineSoft: '#f1f1f4',       // 목록 구분선
  surface: '#ffffff',
  surfaceSoft: '#f7f7f9',    // 상대 말풍선·비활성 배경
  radius: 8,                 // 입력창
  radiusLg: 20,              // 다이얼로그·패널
  shadow: '0 5px 10px 0 rgba(247, 124, 64, 0.16)',     // 포커스 입력창 (MuiOutlinedInput 기본값과 동일)
  cardShadow: '0 5px 15px 0 rgba(247, 124, 64, 0.2)',  // 카드(UseCard 와 동일)
  dialogShadow: '0 0 7px rgba(0, 0, 0, 0.15)',
  rowHeight: 50,
  font: "'NotoSansCJKkr', 'Noto Sans KR', sans-serif",
  zLauncher: 1200,           // 실시간문의 버튼 — 헤더(1100) 위, 다이얼로그(1300) 아래
  zPanel: 1250,
};

export default tokens;
